@if (data.length) {
  <div class="error-container">
  @for (error of data; track error.timestamp) {
      <div class="error-notification">
        <p [innerHTML]="error.translatedMessage"></p>
        @if (error.code) {
          <p class="code">Code: {{ error.code }}</p>
        }
      </div>
  }
  </div>
}
